import React from "react";

/** @typedef {{quantity?: number}} AlbumOwnershipDto
 * quantity is optional for non-owned details and older server versions.
 */
export default function AlbumQuantity({ quantity }) {
  if (!Number.isSafeInteger(quantity) || quantity < 1) return null;
  return (
    <span className="copy-count">
      {quantity} {quantity === 1 ? "copy" : "copies"}
    </span>
  );
}
